var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',_vm._g(_vm._b({staticClass:"costum-select-local",attrs:{"id":_vm.name || _vm.$attrs.id,"value":_vm.value,"size":"sm"}},'b-form-select',_vm.$attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }